import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import makePackagesMassive from './selectors';
import { reducer, name, actions } from './slice';
import saga from './saga';

export default function usePackagesMassive() {
  const dispatch = useDispatch();
  useInjectReducer({ key: name, reducer });
  useInjectSaga({ key: name, saga });
  useSelector(makePackagesMassive(), shallowEqual);
  useEffect(() => {
    return () => {
      dispatch(actions.resetFilters());
      dispatch(actions.clearItems());
    };
  }, [dispatch]);
  return null;
}
